const BASE_URL = 'https://api.yunzong518.com'

function request(path, data) {
  return fetch(`${BASE_URL}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json;charset=utf-8' },
    body: JSON.stringify(data),
  }).then(async (res) => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return res.json()
  })
}

function getReq(path) {
  return fetch(`${BASE_URL}${path}`, {
    method: 'GET',
  }).then(async (res) => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return res.json()
  })
}

/**
 * 通过微信 OAuth code 换取 openid
 * @param {string} code
 * @returns {Promise<{ code: number, data: string, msg: string }>}
 */
export function getOpenid(code) {
  return getReq(`/appointment/api/order/getOpenid?code=${encodeURIComponent(code)}`)
}

/**
 * 创建预约挂号订单
 * @param {object} params
 * @param {string} params.name        就诊姓名
 * @param {number} params.sex         性别 1=男 2=女
 * @param {number} params.age         年龄
 * @param {string} params.tel         联系电话
 * @param {string} params.idCard      身份证号（医保必填）
 * @param {number} params.visitType   就诊类型 1=初诊 2=复诊
 * @param {number} params.paymentType 支付类型 1=非医保 2=医保
 * @param {number} params.payPrice    挂号费（单位：分）
 * @param {string} params.visitDate   就诊日期 YYYY-MM-DD
 * @param {string} params.visitTime   就诊时间段 如 "9:00-10:00"
 * @param {string} params.department  预约科室
 * @param {string} params.openid      微信 openid
 * @returns {Promise<{ code: number, data: string, msg: string }>}
 */
export function createOrder(params) {
  return request('/appointment/api/order/create', params)
}

/**
 * 发起微信 JSAPI 支付
 * @param {{ orderNo: string, openid: string }} params
 * @returns {Promise<{ code: number, data: object, msg: string }>}
 */
export function payOrder(params) {
  return request('/appointment/api/order/pay', params)
}
